import { create } from 'zustand';
import api from '../../api';

const useSuggestionsStore = create((set) => ({
  isLoadingSuggestions: false,
  autocompleteSuggestions: [],

  getSearchSuggestions: async (text) => {
    set({ isLoadingSuggestions: true });

    try {
      const {
        //@ts-ignore
        suggested: { tags = [], titles = [] }
      } = await api.getSearchSuggestions(text);

      const suggestions = [
        ...tags.map((item) => ({
          prefix: 'Tag: ',
          label: item.text,
          value: 'Tag: ' + item.text,
        })),
        ...titles.map((item) => ({
          prefix: 'Title: ',
          label: item.text,
          value: 'Title: ' + item.text,
        })),
      ];

      set({ autocompleteSuggestions: suggestions, isLoadingSuggestions: false });
    } catch (error) {
      set({ isLoadingSuggestions: false });
      console.error("Failed to fetch suggestions", error);
    }
  },

  setSearchSuggestions: (autocompleteSuggestions) => 
    set({ autocompleteSuggestions }),

  setLoadingSuggestions: (isLoadingSuggestions) => 
    set({ isLoadingSuggestions }),
}));

export default useSuggestionsStore;
